export const BEAUTY_AND_TRENDS = 'beauty-and-trends';
export const BEAUTY_AND_TRENDS_MOBILE = 'beauty-and-trends-mobile';
export const BEAUTY_AND_TRENDS_MOBILE_LINK = 'beauty-and-trends-mobile-link';
